<div><img [src]="imageUrl"></div>